import { Component } from '@angular/core';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from "../../core/components/footer/footer.component";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserService } from '../../core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxTgModule, TranslateService } from '@worthy-ventures/metaglotta-ngx';

@Component({
  selector: 'app-contact',
  imports: [MenuBarComponent, FooterComponent, FormsModule, CommonModule, NgxTgModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  name: string = '';
  email: string = '';
  phone: string = '';
  message: string = '';
  submitted: boolean = false;
  /** Swaps the form for the confirmation panel once the message is stored. */
  sent: boolean = false;

  constructor(
    private userService: UserService,
    private toastService: ToastrService,
    private translate: TranslateService,
  ) { }


public sendMessage(nameCtrl: any, emailCtrl: any, phoneCtrl: any, messageCtrl: any): void {
  this.submitted = true;
  let isInvalid = false;

  const validateField = (ctrl: any) => {
    const el = ctrl.valueAccessor._elementRef.nativeElement;
    el.classList.add('shake');
    setTimeout(() => el.classList.remove('shake'), 300);
  };

  // Name empty
  if (!this.name?.trim()) {
    isInvalid = true;
    validateField(nameCtrl);
  }

  // Email empty OR invalid format
  if (!this.email?.trim() || emailCtrl.invalid) {
    isInvalid = true;
    validateField(emailCtrl);
  }

  // Phone empty OR wrong length
  if (!this.phone?.trim() || this.phone.length !== 10) {
    isInvalid = true;
    validateField(phoneCtrl);
  }

  // Message empty
  if (!this.message?.trim()) {
    isInvalid = true;
    validateField(messageCtrl);
  }

  if (isInvalid) return;

  // ✅ All fields valid → send
  this.userService.sendMessage(this.message, 'web', this.phone, this.email, this.name).subscribe({
    next: () => {
      // Keep the values: the confirmation greets the sender by name, and
      // `sent` swaps the form out rather than blanking it.
      this.submitted = false;
      this.sent = true;
      this.toastService.success(this.translate.instant('contact_toast_success'), this.translate.instant('toast_success_title'));
    },
    error: () => {
      this.toastService.error(this.translate.instant('contact_toast_error'), this.translate.instant('toast_error_title'));
    }
  });
}


  sanitizePhone(phoneInput: HTMLInputElement) {
    const phoneNumber = this.phone
      ?.replace(/(?!^\+)[^\d]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (phoneNumber === this.phone) {
      return;
    }
    this.phone = phoneNumber;
    phoneInput.value = this.phone;
  }

  /** Back to an empty form, for sending a second message. */
  public sendAnother(): void {
    this.sent = false;
    this.submitted = false;
    this.name = '';
    this.email = '';
    this.phone = '';
    this.message = '';
  }
}
